import React from 'react';

const RewardInfoIcon = () => (
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.28367 11C3.51282 11 1.25854 8.7575 1.25854 6C1.25854 3.2435 3.51282 1 6.28367 1C9.05452 1 11.3088 3.243 11.3088 6C11.3088 8.7575 9.05452 11 6.28367 11ZM6.28367 2C4.06709 2 2.26357 3.7945 2.26357 6C2.26357 8.2055 4.06709 10 6.28367 10C8.50025 10 10.3038 8.2055 10.3038 6C10.3038 3.7945 8.50025 2 6.28367 2Z"
      fill="#757575"
    />
    <path
      d="M6.78617 7.5V5.5C6.78617 5.224 6.56155 5 6.28366 5H5.27864V6H5.78115V7.5H4.77612V8.5H7.7912V7.5H6.78617Z"
      fill="#757575"
    />
    <path
      d="M6.28366 4.625C6.63057 4.625 6.9118 4.34518 6.9118 4C6.9118 3.65482 6.63057 3.375 6.28366 3.375C5.93675 3.375 5.65552 3.65482 5.65552 4C5.65552 4.34518 5.93675 4.625 6.28366 4.625Z"
      fill="#757575"
    />
  </svg>
);

export default RewardInfoIcon;
